import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getGrillaTalleres } from 'services/servicioGet';
import { Taller } from 'utils/models/types';

interface TalleresGrillaState {
  talleresGrilla: Taller[];
  loadingTalleresGrilla: boolean;
  errorTalleresGrilla: string | null;
}

// Estado inicial del slice
const initialState: TalleresGrillaState = {
  talleresGrilla: [],
  loadingTalleresGrilla: false,
  errorTalleresGrilla: null,
};

// Thunk para obtener los talleres
export const fetchGrillaTalleres = createAsyncThunk('talleres/fetchGrillaTalleres', async (_, { rejectWithValue }) => {
  try {
    const response = await getGrillaTalleres();
    return response;
  } catch (error: unknown) {
    return rejectWithValue(error instanceof Error ? error.message : String(error));
  }
});

// Slice de talleres
const talleresGrillaSlice = createSlice({
  name: 'talleresGrilla',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchGrillaTalleres.pending, state => {
        state.loadingTalleresGrilla = true;
        state.errorTalleresGrilla = null;
      })
      .addCase(fetchGrillaTalleres.fulfilled, (state, action) => {
        state.talleresGrilla = action.payload;
        state.loadingTalleresGrilla = false;
      })
      .addCase(fetchGrillaTalleres.rejected, (state, action) => {
        state.loadingTalleresGrilla = false;
        state.errorTalleresGrilla = action.payload as string;
      });
  },
});

export default talleresGrillaSlice.reducer;
